import React, { useEffect, useState } from 'react';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import DocumentList from '@/seller/components/documents/DocumentList/DocumentList';
import { searchProjectDocuments, ProjectDocumentSearchOptions } from '@/services/documents';
import { ChangedItem, BaseDocument } from '@/types';
import { useDefaultScrollToStringId } from '@/utils/hooks';
import DocumentListSlideup from './DocumentList/DocumentListSlideup';

interface OwnProps {
    filters: ProjectDocumentSearchOptions; //TODO: properly type
}

const ProjectDocumentFilterableList: React.FC<OwnProps> = ({ filters }) => {
    const [documents, setDocuments] = useState<BaseDocument[] | null>(null);
    const [selectedDocuments, setSelectedDocuments] = useState<BaseDocument[]>([]);
    const defaultExpandedId = useDefaultScrollToStringId();

    useEffect(() => {
        async function loadData() {
            setDocuments(null);
            setSelectedDocuments([]);
            setDocuments(await searchProjectDocuments(filters as ProjectDocumentSearchOptions));
        }

        loadData();
    }, [filters]);

    const handleChange = async (changes: ChangedItem<BaseDocument>[]) => {
        if (!documents) return;
        setDocuments(await searchProjectDocuments(filters));
    };

    return (
        <>
            {documents ? (
                <>
                    <DocumentList
                        defaultExpandedId={defaultExpandedId}
                        mode="Project"
                        documents={documents}
                        onChange={handleChange}
                        selectedItems={selectedDocuments}
                        onSelectionChange={setSelectedDocuments}
                        hideSelectAll={true}
                    />
                    <DocumentListSlideup
                        isOpen={selectedDocuments.length > 0}
                        onCloseDialog={() => setSelectedDocuments([])}
                        selectedDocuments={selectedDocuments}
                        onChange={() => handleChange([])}
                    />
                </>
            ) : (
                <LoadingIndicator />
            )}
        </>
    );
};

export default ProjectDocumentFilterableList;
